import { render, staticRenderFns } from "./TeamBySectorMember.vue?vue&type=template&id=98c72318"
import script from "./TeamBySectorMember.vue?vue&type=script&lang=js"
export * from "./TeamBySectorMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports